const passColorEnum = {
  RED: 'red',
  GREEN: 'green',
  ORANGE: 'orange',
  ALL: 'all'
}

Object.freeze(passColorEnum);

const monthMapping = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export { passColorEnum, monthMapping }